// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__gMy_j","active":"NavItem_active__1agX5"};